<div class="flex w-full h-full p-6 gap-6 bg-surface-50 flex-col">
  <p-card>
    <div class="flex flex-col gap-4">
      <div class="flex gap-6 items-center">
        <div class="flex gap-2">
          <input type="text"
                 pInputText
                 class="w-128"
                 data-testid="units-projects-filter"
                 placeholder="Type to filter by unit code/name, project code/name..."
                 [ngModel]="filterInput()"
                 (ngModelChange)="filterInput.set($event)"
          />
          <div class="bg-white rounded-lg">
            <p-button outlined severity="secondary"
                      (onClick)="clearGlobalFilter()"
            >Clear</p-button>
          </div>
        </div>

        <p-select
          [options]="statusOptions"
          placeholder="Status"
          showClear
          (onChange)="tt.filter($event.value, 'active', 'equals')"
          style="padding: 0;"
        >
          <ng-template #selectedItem let-status>
            @if (status) {
              <p-tag [severity]="status.severity" rounded [value]="status.label" size="small" />
            }
          </ng-template>
          <ng-template #item let-status>
            <p-tag [severity]="status.severity" rounded [value]="status.label" size="small" />
          </ng-template>
        </p-select>

        <div class="flex-1"></div>
        <div class="bg-white rounded-lg">
          <p-button outlined severity="secondary" size="small" icon="fa-regular fa-file-export" label="Units and Projects Export"
                    data-testid="units-projects-export-button" [loading]="exporting()" (onClick)="exportUnitsAndProjects()"></p-button>
        </div>
        <p-button label="Add Unit" icon="fa-regular fa-plus" (onClick)="openAddUnitModal()"></p-button>
        <p-button label="Add Project" icon="fa-regular fa-plus" (onClick)="openAddProjectModal()"></p-button>
      </div>
      <div scrollHeight class="rounded-lg border border-surface-300 overflow-y-auto">
        <p-tree-table
          #tt
          [value]="tableRows"
          [tableStyle]="{ 'min-width': '60rem' }"
          [globalFilterFields]="['name','code']"
          [filterDelay]="0"
          filterMode="lenient"
          size="small"
          (onFilter)="onTableFilter($event.filteredValue)"
        >
          <ng-template #header let-columns>
            <tr>
              <th>Code</th>
              <th>Name</th>
              <th>
                Unit Manager
                <p class="font-light text-xs">* indicates acting manager</p>
              </th>
              <th>
                No. of Approvers
                <p class="font-light text-xs">Total (Unit Approvers/ Project Approvers)</p>
              </th>
              <th class="w-28">Status</th>
              <th class="w-24"></th>
            </tr>
          </ng-template>
          <ng-template #body let-rowNode let-rowData="rowData" let-columns="columns">
            <tr [ttRow]="rowNode" [class.row-striped]="rowData.striped">
              <td>
                <div class="flex items-center gap-2">
                  <p-treetable-toggler [rowNode]="rowNode" />
                  <span class="font-medium">
                        {{ rowData.code }}
                      </span>
                </div>
              </td>
              <td>
                {{ rowData.name }}
              </td>
              <td>
                @if (rowNode.level === 0) {
                  @if (rowData.actingManager) {
                    *{{ rowData.actingManager.name }}@if (rowData.actingTo) { (until {{ rowData.actingTo | date: 'dd/MM/yy' }})}
                  } @else {
                    {{ rowData.managers?.[0]?.name }}
                  }
                }
              </td>
              <td>
                @if (rowNode.level === 0) {
                  {{(rowData.approvers?.length ?? 0) + rowData.approverSum  + " (" + (rowData.approvers?.length ?? 0) + " / " + rowData.approverSum + ")" }}
                } @else if (rowNode.level === 1) {
                  {{rowData.approvers?.length ?? 0}}
                }
              </td>
              <td>
                @if (rowData?.active) {
                  <p-tag severity="info" rounded value="Active" />
                } @else {
                  <p-tag severity="secondary" rounded value="Inactive" />
                }
              </td>
              <td>
                <div class="flex justify-end">
                  <p-button class="edit" size="small" (onClick)="openModal(rowData)">
                    <span>Edit</span>
                    <i class="fa-light fa-pencil"></i>
                  </p-button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-tree-table>
      </div>
    </div>
  </p-card>
  <div class="p-2.5 w-full"></div>
</div>
